import { TOKEN } from "constants/user";
import { ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchMeAction } from "store/actions/userAction";
import { AppDispatch } from "store/config";

export default function AuthGuard({ children }: { children?: ReactNode }) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const isLoggedIn = !!localStorage.getItem(TOKEN);

    if (!isLoggedIn) {
      navigate("/auth/login");
    }

    dispatch(fetchMeAction());
  }, []);

  return <>{children}</>;
}
